import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "shareIosFilled"
const ShareIosFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M8.275 8.063Q8.25 8.153 8.25 8.25V9.75Q8.251 9.847 8.275 9.938H5.062V20.813H18.188V9.938H15.726Q15.75 9.848 15.75 9.75V8.25Q15.749 8.153 15.725 8.063H18.375C19.307 8.063 20.063 8.818 20.063 9.75V21C20.063 21.932 19.307 22.688 18.375 22.688H4.875C3.943 22.688 3.188 21.932 3.188 21V9.75C3.188 8.818 3.943 8.063 4.875 8.063z" />
          <path d="M16.413 5.712 15.087 7.038 12.937 4.888V8.063H12.963Q12.94 8.153 12.938 8.25V9.75Q12.938 9.847 12.962 9.938H12.938V15.75H11.062V9.938H11.039Q11.06 9.848 11.062 9.75V8.25Q11.063 8.153 11.039 8.063H11.062V4.888L8.913 7.038 7.588 5.712 12 1.3z" />
        </svg>
      }
    </span>
  )
}
export default ShareIosFilledIcon
